import { Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

export const useFormSelectStyles = makeStyles()((theme: Theme) => ({
	label: {
		marginBottom: theme.spacing(1),
		marginTop: 0,
		fontWeight: theme.typography.fontWeightMedium,
	},
	selectField: {
		height: theme.spacing(5),
		textAlign: "left",
	},
	input: {
		"&[aria-disabled]": {
			cursor: "not-allowed",
			pointerEvents: "auto",
		},
	},
	menuList: {
		"& [aria-label='placeholder']": {
			justifyContent: "center",
		},
	},
	placeholder: {
		color: theme.palette.grey[500],
		"&[aria-disabled='true']": {
			WebkitTextFillColor: theme.palette.text.disabled,
			opacity: 0.5,
		},
	},
	clearButton: {
		position: "absolute",
		right: theme.spacing(3.5),
		top: "calc(50% - 0.5em)",
		padding: 0,

		"&:hover": {
			backgroundColor: "inherit",
		},

		svg: {
			width: theme.spacing(2.5),
			height: theme.spacing(2.5),
		},
	},
}));
